import PropTypes from 'prop-types';
import styles from './FJTextBaseEditVideoRight.module.less';
import { useEffect, useRef, useCallback } from 'react';

const FJTextBaseEditVideoRight = ({ setVideoCanvas, pause, resize }) => {
    const videoCanvasRef = useRef(null);

    useEffect(() => {
        window.addEventListener('resize', resize);

        return () => {
            window.removeEventListener('resize', resize);
        };
    }, [resize]);

    useEffect(() => {
        setVideoCanvas(videoCanvasRef.current);
    }, [setVideoCanvas]);

    const mouseDown = useCallback(() => {
        pause && pause();
    }, [pause]);

    return (
        <div className={styles.container} onMouseDown={mouseDown}>
            <canvas ref={videoCanvasRef} className={styles.video_canvas} />
        </div>
    );
};

FJTextBaseEditVideoRight.propTypes = {
    setVideoCanvas: PropTypes.func.isRequired,
    pause: PropTypes.func,
    resize: PropTypes.func,
};

export default FJTextBaseEditVideoRight;
